import { useCallback, useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useSearcher } from 'components/modules/Insurance/hooks/useSearcher';
import * as CarInstanceActions from 'store/carInstance/actions';
import * as CarInstanceConstants from 'store/carInstance/constants';
import * as CarInstanceSelectors from 'store/carInstance/selectors';
import * as CarReferenceSelectors from 'store/carReference/selectors';

import { useDisabledFields } from '../../hooks/useDisabledFields';

import { NAME } from './VersionSearcher.constants';

export const useVersionSearcherPresenter = () => {
  const dispatch = useDispatch();

  const { [NAME]: disabled } = useSelector(CarInstanceSelectors.selectDisabled);
  const { [NAME]: error } = useSelector(CarInstanceSelectors.selectErrors);
  const versions = useSelector(CarReferenceSelectors.selectVersions) ?? [];
  const versionsFetch = useSelector(CarReferenceSelectors.selectVersionsFetch);
  const { id: value } = useSelector(CarReferenceSelectors.selectSelectedVersion) ?? {};

  const { disabled: pageRestrict } = useDisabledFields();

  const data = useMemo(() => {
    return versions.reduce((acc, version) => {
      const { value: title, ...rest } = version ?? {};

      if (typeof title === 'string') {
        acc.push({ ...rest, title });
      }

      return acc;
    }, []);
  }, [versions]);

  const presenter = useSearcher({ data });

  const onChange = useCallback(({ [NAME]: value }) => {
    const { title } = value;
    let { enginePower, price } = value;

    enginePower ||= null;
    price ||= 0;

    dispatch(
      CarInstanceActions.setCarInstance({
        [NAME]: title,
        [CarInstanceConstants.VALUE_FIELDS.DEFAULT_PRICE]: price,
        [CarInstanceConstants.VALUE_FIELDS.DISCOUNT_TYPE]: null,
        [CarInstanceConstants.VALUE_FIELDS.ENGINE_POWER]: enginePower,
        [CarInstanceConstants.VALUE_FIELDS.OFFER_PRICE]: price,
        [CarInstanceConstants.VALUE_FIELDS.PRICE]: price,
        [CarInstanceConstants.VALUE_FIELDS.YEAR]: undefined,
      })
    );
    dispatch(
      CarInstanceActions.updateErrors({
        [NAME]: '',
        [CarInstanceConstants.VALUE_FIELDS.YEAR]: '',
      })
    );
  }, []);

  return {
    ...presenter,
    disabled: disabled || versionsFetch || pageRestrict,
    error,
    onChange,
    value,
  };
};
